
import { ArticleItem } from '@/components/article'
import { ProductItem } from '@/components/product'
import i18n from '@/i18n'
import Vue from 'vue'

export default Vue.extend({

    components: { ProductItem, ArticleItem },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,
            country: {},
            articles: {},
            products: {},
        }
    },
    async mounted() {
        try {
            // Country
            const country = await this.$axios.get('/country', {
                params: {
                    fields: '*,translations.*',
                    'filter[translations][slug][_eq]': this.$route.params.slug,
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                    sort: 'date_created',
                    'filter[status][_eq]': 'published'
                }
            })
            this.country = country.data.data[0].translations[0]

            const [products, articles] = await Promise.all([

                // Products
                this.$axios.get('/product', {
                    params: {
                        fields: '*,translations.*,translations.countries.*,translations.category.*',
                        'filter[translations][countries][country_id][_eq]': this.country.country_id,
                        'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                        sort: 'date_created',
                        'filter[status][_eq]': 'published'
                    }
                }),

                this.$axios.get('/article', {
                    params: {
                        fields: '*,translations.*',
                        'filter[type][_eq]': 'experience',
                        'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                        sort: 'date_created',
                        'filter[status][_eq]': 'published'
                    }
                })
            ])



            this.products = products.data.data
            this.articles = articles.data.data

        } catch (error) {
            console.error('Error fetching data:', error)
        }
    },

    metaInfo() {
        return {
            title: `${this.country.name} | Bobu Africa`,
            link: [
                { rel: "canonical", href: `${window.location.href}` }
            ],
            meta: [
                { name: 'description', content: `${this.country.name} | Bobu Africa` },
                { property: "og:type", content: "website" },
                { property: "og:url", content: `${window.location.href}` },
                { property: "og:title", content: `${this.country.name} | Bobu Africa}` },
                { property: "og:description", content: `${this.country.name} | Bobu Africa` },
                { property: "og:image", content: `${this.$assets}/${this.country.image}` },

                { property: "twitter:card", content: "summary_large_image" },
                { property: "twitter:url", content: `${window.location.href}` },
                { property: "twitter:title", content: `${this.country.name}` },
                { property: "twitter:description", content: `${this.country.name} | Bobu Africa` },
                { property: "twitter:image", content: `${this.$assets}/${this.country.image}` },
            ]
        }
    },
})

